<template>
    <div>
        <div class="alert alert-light border-warning mb-2" v-for="(doc, idc) in lista_documentos" :key="'doc' + idc">
            <span class="close" v-if="doc.doc_certificado && doc.doc_certificado_link">
                <a href="#" class="alert-link mr-1 ml-2" @click.prevent="cancelar(doc)">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                </a>
            </span>
            <span class="close" v-if="doc.doc_certificado && doc.doc_certificado_link">
                <a :href="doc.doc_certificado_link" class="alert-link mr-1 ml-2" target="_blank">
                    <i class="fas fa-file-contract"></i>
                </a>
            </span>

            <span class="close" v-else-if="pode_assinar && 1==0">
                <a href="#" class="alert-link mr-1 ml-2" @click.prevent="assinar(doc)">
                    <i class="fas fa-signature"></i>
                </a>
            </span>

            <template v-if="false">
                <span class="close">
                    <a href="#" @click.prevent="imprimir_documento(doc)" class="alert-link" title="Imprimir">
                        <i class="fas fa-print"></i>
                    </a>
                </span>
                <span class="close" v-if="false">
                    <a class="alert-link mx-2" href="#" @click.prevent="$refs.documento.editar(doc)" title="Editar">
                        <i class="far fa-file-alt"></i>
                    </a>
                </span>
                <span class="close text-danger small" v-if="doc.removendo">
                    <div class="spinner-border spinner-border-sm" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </span>
            </template>
            <div>
                <div :class="doc.hide ? '' : 'mb-3'">
                    <a href="#" @click.prevent="doc.hide = !doc.hide" class="alert-link mr-2" title="Exibição">
                        <i class="far fa-minus-square" v-if="!doc.hide"></i>
                        <i class="far fa-plus-square" v-else></i>
                    </a>
                    {{ doc.st_titulo }}
                    <span v-if="doc.modelo_documento && doc.modelo_documento.st_nome && doc.modelo_documento.st_nome != doc.st_titulo" class="text-muted">
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        {{ doc.modelo_documento.st_nome }}
                    </span>
                </div>
                <div v-show="!doc.hide">
                    <div v-if="doc.fl_formulario">
                        <formulario v-model="doc.estrutura" mode="view" />
                    </div>
                    <div v-else v-html="doc.texto_html"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Formulario from './Formulario.vue';

export default {
    data() {
        return { 

        };
    },

    props: [
        'atendimento',
        'lista_documentos',
    ], 

    components: { 
        Formulario, 
    },

    computed: { 
        pode_assinar: function () { 
            let id_medico;
            let medico = this.$store.state.user.medico;

            if ( !medico && this.atendimento ) { 
                if ( this.$store.state.user.delegantes_medicos.find(deleg => deleg.delegante.id_pessoa == this.atendimento.medico.id_pessoa) ) { 
                    id_medico = this.atendimento.medico.id_pessoa;
                }
            } else { 
                id_medico = this.$store.state.user.id_pessoa;
            }

            return this.atendimento && this.atendimento.medico.id_pessoa == id_medico; // && this.atendimento.medico.tem_certificado 
        },
    },

    methods: { 
        imprimir_documento(doc) {
            if ( doc ) {
                this.$util.print_preview('imprimir/documento/' + doc.id_documento_atendimento, true, { noass: 1 }, true);
            }
        },
    }
}
</script>
